<template>
  <div class="addDalog">
    <el-dialog
      title="多账户"
      append-to-body
      width="750px"
      :visible.sync="visible"
      @close="closeDialog"
      :show="show"
    >
      <div class="content_box_s">
        <div v-for="(itme, index) in Costs" :key="index">
          <div
            class="InputThree"
            v-if="itme.AtypeId != '000040000800001' && itme.AtypeId != '多账户'"
          >
            <span class="label_name">{{ itme.FullName }}</span>
            <el-input
              v-model="itme.Total"
              size="mini"
              @blur="doBlur"
              @focus="doFocus"
              class="input_sty"
              @input="
                itme.Total = itme.Total.replace(
                  /^\D*(\d*(?:\.\d{0,6})?).*$/g,
                  '$1'
                )
              "
            ></el-input>
          </div>
        </div>
        <p>￥{{ total_amount }}</p>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" @click="saveInfor"
            >保 存</el-button
          >
          <el-button size="mini" @click="visible = false">取 消</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>  

<script>
import tool from "@/utils/tool"; //工具类
export default {
  data() {
    return {
      total_Discount: false, // 优惠金额
      total_amount: "0.00", // 金额合计
      visible: this.show,
      Costs_data: this.Costs,
      FullName: "",
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    Costs: Array,
  },
  methods: {
    doBlur() {
      let t = 0;
      let N = this.Costs.length;
      for (const key in this.Costs) {
        if (this.Costs.hasOwnProperty(key)) {
          const element = this.Costs[key];
          if (
            element.AtypeId != "000040000800001" &&
            element.AtypeId != "多账户"
          ) {
            if (Number(element.Total) <= 0) {
              N--;
            }
            t = tool.accAdd(t, Number(element.Total));
          }
        }
      }
      if (N != 1) {
        this.total_Discount = true;
      } else {
        this.total_Discount = false;
      }
      this.total_amount = t.toFixed(tool.getLocal("get_config").moneyPoint);
    },
    dateChange(value, data) {
      console.log(value, data);
    },
    // 保存
    saveInfor() {
      console.log(this.Costs);
      this.$emit(
        "dateChange",
        this.Costs, // 多单位数据
        this.total_amount, // 单位金额合计
        this.total_Discount // 优惠金额
      );
    },
    // 聚焦事件
    doFocus() {
      event.currentTarget.select();
    },
    // 关闭弹出框前回调
    closeDialog() {
      this.$emit("update:show", false);
    },
    // 当前input值改变
    dateChange(data, fieldData) {},
    // 回填数据
    backData(data, fieldData) {},
  },
  watch: {
    show() {
      this.visible = this.show;
      if (this.show) {
        this.doBlur();
      }
    },
  },
  created() {},
};
</script>
<style lang="less" scoped>
.width_100 {
  width: 100%;
}
.InputThree {
  width: 100%;
  height: 30px;
  display: -webkit-box !important;
  display: box !important;
  position: relative;
  -webkit-box-align: center;
  box-align: center;
  color: #666;
  border: 1px solid #d6e2ed;
  border-radius: 5px;
  padding: 0 5px;
  box-sizing: border-box;
  margin-top: 6px;
  .label_name {
    height: 100%;
    line-height: 30px;
    font-size: 12px;
    color: inherit;
    font-weight: bold;
  }
  .isMust::after {
    content: "*";
    color: red;
  }
  .input_sty {
    position: relative;
    -webkit-box-flex: 1;
    box-flex: 1;
    display: block;
    height: 100%;
  }
  .el-input__inner,
  .el-input__inner:hover {
    border-color: #fff;
    height: 27px;
    outline: none;
    background: transparent;
    border: none;
  }
}
.el-input.is-disabled .el-input__inner {
  background-color: #fff;
  border-color: #fff;
  color: #333;
}
.InputThree:hover {
  border-color: #2594ff;
  color: #2594ff;
}
.InputThree_active {
  border-color: #2594ff !important;
  color: #2594ff !important;
}
.content_box_s {
  p {
    text-align: right;
    margin: 6px 0 0 0;
  }
  .dialog-footer {
    width: 100%;
    display: -webkit-box !important;
    display: box !important;
    position: relative;
    -webkit-box-pack: end;
    box-pack: end;
    margin: 20px 0 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/manyUnit/manyUnit.vue